var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value == '1')?_c('v-btn',{attrs:{"color":"success","small":"","text":""}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(" mdi-check-bold ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }